// src/components/PWAFooter.jsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Briefcase, FileText, Users, HelpCircle } from 'lucide-react';

const PWAFooter = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Check if running as PWA
  const isPWA = window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;

  // Don't render if not PWA
  if (!isPWA) {
    return null;
  }

  const navItems = [
    {
      id: 'home',
      label: 'Home',
      icon: Home,
      path: '/',
      activeColor: 'text-blue-600'
    },
    {
      id: 'gigs',
      label: 'Gigs',
      icon: Briefcase,
      path: '/gigs',
      activeColor: 'text-blue-600'
    },
    {
      id: 'requests',
      label: 'Requests',
      icon: FileText,
      path: '/requests',
      activeColor: 'text-blue-600'
    },
    {
      id: 'giggers',
      label: 'Giggers',
      icon: Users,
      path: '/giggers',
      activeColor: 'text-blue-600'
    },
    {
      id: 'help',
      label: 'Help',
      icon: HelpCircle,
      path: '/support',
      activeColor: 'text-blue-600'
    }
  ];

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 safe-area-inset-bottom">
      <div className="flex justify-around items-center h-16 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <button
              key={item.id}
              onClick={() => handleNavigation(item.path)}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${active
                  ? item.activeColor
                  : 'text-gray-600 hover:text-gray-900'
                }`}
              aria-label={item.label}
            >
              <Icon
                className={`w-6 h-6 mb-1 ${active ? 'stroke-2' : 'stroke-1.5'}`}
              />
              <span className={`text-xs ${active ? 'font-semibold' : 'font-normal'}`}>
                {item.label}
              </span>
              {active && (
                <div className="absolute bottom-0 w-12 h-1 bg-blue-600 rounded-t-full" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default PWAFooter;